import { render } from "./VerList.vue?vue&type=template&id=2ba1e3f4&scoped=true"
import script from "./VerList.vue?vue&type=script&lang=js"
export * from "./VerList.vue?vue&type=script&lang=js"

import "./VerList.vue?vue&type=style&index=0&id=2ba1e3f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba1e3f4"]])

export default __exports__